import { ApiInstance } from '../instance';

export type BillingStatus = 'active' | 'inactive' | 'suspended';

export interface BillingStatusResponse {
  billing_status: BillingStatus;
  billing_threshold: number;
  current_unbilled_spend: number;
  stripe_payment_method_id?: string;
}

export interface PaymentMethodResponse {
  brand: string;
  last4: string;
  exp_month: number;
  exp_year: number;
}

export interface TransactionResponse {
  id: string;
  created: number;
  amount_paid?: number;
  amount_due?: number;
  amount?: number;
  status: string;
  invoice_pdf?: string;
  receipt_url?: string;
}

export interface PaymentVerificationResponse {
  paymentIntentId: string;
  adAccount?: unknown;
}

export interface SettlementResponse {
  settled: boolean;
  paymentIntentId?: string;
  reason?: string;
  adAccount?: unknown;
  advertiser?: unknown;
}

export const BillingController = {
  getStatus: async (): Promise<{ data: BillingStatusResponse }> => {
    return await ApiInstance.get('/advertisers/billing/status');
  },
  verifyPaymentMethod: async (
    payment_method_id: string
  ): Promise<{ data: PaymentVerificationResponse }> => {
    return await ApiInstance.post('/advertisers/billing/verify-payment-method', {
      payment_method_id,
    });
  },
  verifyPortalPaymentMethod: async (): Promise<{ data: PaymentVerificationResponse }> => {
    return await ApiInstance.post('/advertisers/billing/verify-portal-payment-method', {});
  },
  syncPaymentMethod: async (): Promise<{ data: PaymentMethodResponse | null }> => {
    return await ApiInstance.post('/advertisers/billing/payment-method/sync', {});
  },
  updateThreshold: async (
    billing_threshold: number
  ): Promise<{ data: BillingStatusResponse }> => {
    return await ApiInstance.post('/advertisers/billing/threshold', {
      billing_threshold,
    });
  },
  settle: async (
    force?: boolean
  ): Promise<{ data: SettlementResponse }> => {
    return await ApiInstance.post('/advertisers/billing/settle', {
      force,
    });
  },
};
